import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-email-reply-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfEmailReplyIconProps extends SvgIconProps  {}

/**
 *This icon used on button for email reply
 * @param props -  CcfEmailReplyIconProps
 * @example <CcfEmailReplyIcon />
 * @returns
 */
export function CcfEmailReplyIcon(props: CcfEmailReplyIconProps) {
  return (
    <SvgIcon
      width="17"
      height="11"
      viewBox="0 0 17 11"
      fill="none"
      {...props}
    >
      <path
        d="M16.3054 10.999C16.3054 10.999 14.3534 3.19898 6.6545 3.19898V0.000976562L0.512695 5.27098L6.6545 10.632V7.14198C10.8333 7.14098 14.1258 7.47998 16.3054 10.999Z"
        fill="white"
      />
    </SvgIcon>
  );
}

export default CcfEmailReplyIcon;
